<template>
  <div>
    <el-input
      class="search-el"
      size="mini"
      v-model="query.search"
      :clearable="true"
      placeholder="评论内容/课程名称"
    ></el-input>
    <el-select
      class="search-el"
      size="mini"
      v-model="query.audit_status"
      placeholder="显示状态"
    >
      <el-option label="全部" value="">全部</el-option>
      <el-option label="隐藏" value="0">隐藏</el-option>
      <el-option label="显示" value="1">显示</el-option>
    </el-select>
    <el-button type="primary" size="mini" @click="getList()"> 查询 </el-button>

    <el-row>
      <el-table
        v-loading="loading"
        :data="list"
        border
        size="mini"
        :stripe="true"
        style="width: 100%; margin: 20px 0"
      >
        <el-table-column
          label="用户ID"
          align="center"
          min-width="8%"
          prop="user_id"
        ></el-table-column>
        <el-table-column
          label="昵称"
          align="center"
          min-width="12%"
          prop="nickname"
        ></el-table-column>
        <el-table-column label="头像" align="center" min-width="8%">
          <template slot-scope="{ row }">
            <img :src="row.avatar" style="width: 40px" alt="" />
          </template>
        </el-table-column>
        <el-table-column
          label="课程"
          align="center"
          min-width="10%"
          prop="title"
        ></el-table-column>
        <el-table-column
          label="评论内容"
          align="center"
          min-width="20%"
          prop="content"
        ></el-table-column>

        <el-table-column
          prop="created_at"
          label="时间"
          align="center"
          min-width="12%"
        ></el-table-column>
        <el-table-column label="状态" align="center" min-width="8%">
          <template slot-scope="{ row }">
            {{ row.audit_status == 1 ? "显示" : "隐藏" }}
          </template>
        </el-table-column>

        <el-table-column label="操作" align="center" width="200">
          <template slot-scope="{ row }">
            <el-button
              type="danger"
              size="small"
              @click="userCommentDelete(row.id)"
            >
              删除
            </el-button>

            <el-button
              v-show="row.audit_status == 0"
              type="text"
              size="mini"
              @click="auditCourseComment(row.id)"
            >
              <div>显示</div>
            </el-button>

            <el-button
              v-show="row.parent_id == 0"
              type="text"
              size="mini"
              @click="replyCourseComment(row.id)"
            >
              <div>回复</div>
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-row>
    <el-row>
      <div class="block">
        <el-pagination
          background
          @current-change="getList"
          :current-page.sync="query.page"
          :page-size="query.limit"
          layout="total, prev, pager, next, jumper"
          :total="total"
        >
        </el-pagination>
      </div>
    </el-row>
  </div>
</template>

<script>
import { getUserComment, userCommentDelete, auditCourseComment, replyCourseComment } from "@/api/user";

export default {
  data: function () {
    return {
      list: [],
      loading: false,
      total: 0,
      query: {
        page: 1,
        limit: 10,
        search: "",
        title: "",
      },
    };
  },
  created: function () {
    this.getList();
  },
  methods: {
    getList() {
      this.loading = true;
      getUserComment(this.query).then((response) => {
        this.list = response.data.list;
        this.total = response.data.total;
        this.loading = false;
      });
    },

    auditCourseComment(id) {
      this.$confirm("是否将该评价改为“显示”状态", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        auditCourseComment({
          id: id,
        }).then((response) => {
          if (response.status == 2000) {
            this.getList();
            this.$message({
              showClose: true,
              message: "设置成功",
              type: "success",
            });
          } else {
            this.$message({
              showClose: true,
              message: response.message,
              type: "error",
            });
          }
        });
      }).catch(action => {});

    },

    userCommentDelete(id) {
      this.$confirm("此操作将删除该评论, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        userCommentDelete({
          id: id,
        }).then((response) => {
          if (response.status == 2000) {
            this.getList();
            this.$message({
              showClose: true,
              message: "删除成功",
              type: "success",
            });
          }
        });
      }).catch(action => {});
    },

    replyCourseComment(id) {
      this.$prompt("请输入", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      })
        .then(({ value }) => {
          replyCourseComment({
            id: id,
            content: value,
          }).then((response) => {
            if (response.status == 2000) {
              this.getList();
              this.$message({
                showClose: true,
                message: "设置成功",
                type: "success",
              });
            } else {
              this.$message({
                showClose: true,
                message: response.message,
                type: "error",
              });
            }
          });
        })
        .catch(() => {});
    },
  },
  mounted() {},
};
</script>